module.exports = __webpack_public_path__ + "static/media/asm7.465937cd.jpg";